export function getSecurityOptions() {
    return [
        {
            key: 'None',
            text: 'None',
        },
        {
            key: 'Ssl',
            text: 'SSL',
        },
        {
            key: 'Tls',
            text: 'TLS',
        },
    ];
}
//# sourceMappingURL=getSecurityOptions.js.map